/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider, AuthContextProvider } from "context";
import { ProfileProvider } from "context/profile";
import { ScheduleProvider } from "context/schedule";
import { ClientProvider } from "context/client";
import { ContractProvider } from "context/contract";
import { UpgradeProvider } from "context/upgrade";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <AuthContextProvider>
      <MaterialUIControllerProvider>
        <ProfileProvider>
          <ScheduleProvider>
            <ClientProvider>
              <ContractProvider>
                <UpgradeProvider>
                  <App />
                </UpgradeProvider>
              </ContractProvider>
            </ClientProvider>
          </ScheduleProvider>
        </ProfileProvider>
      </MaterialUIControllerProvider>
    </AuthContextProvider>
  </BrowserRouter>
);